/**
 * Copyright (c) 2024, CYBRA Corp. All rights reserved.
 */

import { Component, EventEmitter, Input, Output, Renderer2, ElementRef } from '@angular/core';


@Component({
  selector: 'app-dropdown-menu',
  templateUrl: './dropdown-menu.component.html',
  // styleUrls: ['./../../../../../src/assets/css/ef.css']
   styleUrls: ['./dropdown-menu.component.css']
})

// Add comments
export class DropdownMenuComponent {
  
  @Input() items: any[] = [];
  @Input() x = 0;
  @Input() y = 0;
  
  @Output() selectedItemChange = new EventEmitter<any>();
  selectedItem: any;

  constructor(private rendered: Renderer2, private el: ElementRef) {}

  onItemClick(item: any): void {
    this.selectedItem = item;
    this.close();
    this.selectedItemChange.emit(this.selectedItem);
  }

  close(): void {
    this.items = []
  }

  ngOnInit() {
    this.rendered.listen('document','click', (event) => {
      this.close();
    });

    this.rendered.listen(this.el.nativeElement, 'click', (event) => {
      event.stopPropagation();
    })
  }

}
